// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24770","selected":"styles_selected__3KOf2"};